const API_URL = "https://connect.leadrat.com/api/v1/integration/GoogleAds";
const API_KEY = "NDQ1ZTIzNDktMWMyOC00MTJjLWI1MTgtMDczOGM1N2NiODFm";

export async function submitEnquiry({ name, mobile, email, notes }) {
  const payload = { name, email, mobile, notes };

  const [crmResult] = await Promise.allSettled([
    fetch(API_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json", "API-Key": API_KEY },
      body: JSON.stringify({ ...payload, countryCode: "91" }),
    }).then((res) => { if (!res.ok) throw new Error("CRM failed"); }),

    fetch("/send-mail.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    }),
  ]);

  if (crmResult.status === "rejected") throw new Error("Submission failed");
}
